(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4069],{

/***/ 93345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qE": function() { return /* binding */ Avatar; }
});

// UNUSED EXPORTS: AvatarBadge, AvatarGroup, GenericAvatarIcon, useAvatarStyles

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 3 modules
var index_esm = __webpack_require__(83961);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.esm.js
var dist_index_esm = __webpack_require__(54520);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-context/dist/index.esm.js
var react_context_dist_index_esm = __webpack_require__(28387);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-safe-layout-effect/dist/index.esm.js
var react_use_safe_layout_effect_dist_index_esm = __webpack_require__(44040);
// EXTERNAL MODULE: ./node_modules/react/cjs/react.production.min.js
var react_production_min = __webpack_require__(72408);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
// ../../../react-shim.js


// src/image.tsx


// ../../utilities/object-utils/src/index.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone)
      delete clone[key];
  }
  return clone;
}

// src/use-image.ts


function useImage(props) {
  const {
    loading,
    src,
    srcSet,
    onLoad,
    onError,
    crossOrigin,
    sizes,
    ignoreFallback
  } = props;
  const [status, setStatus] = (0,react_production_min.useState)("pending");
  (0,react_production_min.useEffect)(() => {
    setStatus(src ? "loading" : "pending");
  }, [src]);
  const imageRef = (0,react_production_min.useRef)();
  const load = (0,react_production_min.useCallback)(() => {
    if (!src)
      return;
    flush();
    const img = new Image();
    img.src = src;
    if (crossOrigin)
      img.crossOrigin = crossOrigin;
    if (srcSet)
      img.srcset = srcSet;
    if (sizes)
      img.sizes = sizes;
    if (loading)
      img.loading = loading;
    img.onload = (event) => {
      flush();
      setStatus("loaded");
      onLoad == null ? void 0 : onLoad(event);
    };
    img.onerror = (error) => {
      flush();
      setStatus("failed");
      onError == null ? void 0 : onError(error);
    };
    imageRef.current = img;
  }, [src, crossOrigin, srcSet, sizes, onLoad, onError, loading]);
  const flush = () => {
    if (imageRef.current) {
      imageRef.current.onload = null;
      imageRef.current.onerror = null;
      imageRef.current = null;
    }
  };
  (0,react_use_safe_layout_effect_dist_index_esm/* useSafeLayoutEffect */.G)(() => {
    if (ignoreFallback)
      return void 0;
    if (status === "loading") {
      load();
    }
    return () => {
      flush();
    };
  }, [status, load, ignoreFallback]);
  return ignoreFallback ? "loaded" : status;
}
var shouldShowFallbackImage = (status, fallbackStrategy) => status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";

// src/native-image.tsx

var NativeImage = (0,index_esm/* forwardRef */.Gp)(function NativeImage2(props, ref) {
  const { htmlWidth, htmlHeight, alt, ...rest } = props;
  return /* @__PURE__ */ react.createElement("img", {
    width: htmlWidth,
    height: htmlHeight,
    ref,
    alt,
    ...rest
  });
});
NativeImage.displayName = "NativeImage";

// src/image.tsx
var Image2 = (0,index_esm/* forwardRef */.Gp)(function Image3(props, ref) {
  const {
    fallbackSrc,
    fallback,
    src,
    srcSet,
    align,
    fit,
    loading,
    ignoreFallback,
    crossOrigin,
    fallbackStrategy = "beforeLoadOrError",
    referrerPolicy,
    ...rest
  } = props;
  const providedFallback = fallbackSrc !== void 0 || fallback !== void 0;
  const shouldIgnoreFallbackImage = loading != null || ignoreFallback || !providedFallback;
  const status = useImage({
    ...props,
    ignoreFallback: shouldIgnoreFallbackImage
  });
  const showFallbackImage = shouldShowFallbackImage(status, fallbackStrategy);
  const shared = {
    ref,
    objectFit: fit,
    objectPosition: align,
    ...shouldIgnoreFallbackImage ? rest : omit(rest, ["onError", "onLoad"])
  };
  if (showFallbackImage) {
    if (fallback)
      return fallback;
    return /* @__PURE__ */ react.createElement(index_esm/* chakra.img */.m$.img, {
      as: NativeImage,
      className: "chakra-image__placeholder",
      src: fallbackSrc,
      ...shared
    });
  }
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.img */.m$.img, {
    as: NativeImage,
    src,
    srcSet,
    crossOrigin,
    loading,
    referrerPolicy,
    className: "chakra-image",
    ...shared
  });
});
Image2.displayName = "Image";

// src/img.tsx

var Img = (0,index_esm/* forwardRef */.Gp)((props, ref) => /* @__PURE__ */ react.createElement(index_esm/* chakra.img */.m$.img, {
  ref,
  as: NativeImage,
  className: "chakra-image",
  ...props
}));


// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-children-utils/dist/index.esm.js
var react_children_utils_dist_index_esm = __webpack_require__(34031);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/avatar/dist/index.esm.js
// ../../../react-shim.js


// src/avatar.tsx


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
var dataAttr = (condition) => condition ? "" : void 0;
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}

// src/avatar-context.tsx

var [AvatarStylesProvider, useAvatarStyles] = (0,react_context_dist_index_esm/* createContext */.k)({
  name: `AvatarStylesContext`,
  hookName: `useAvatarStyles`,
  providerName: "<Avatar/>"
});

// src/avatar-image.tsx




// src/avatar-name.tsx

function initials(name) {
  const [firstName, lastName] = name.split(" ");
  return firstName && lastName ? `${firstName.charAt(0)}${lastName.charAt(0)}` : firstName.charAt(0);
}
function AvatarName(props) {
  const { name, getInitials, ...rest } = props;
  const styles = useAvatarStyles();
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    role: "img",
    "aria-label": name,
    ...rest,
    __css: styles.label
  }, name ? getInitials == null ? void 0 : getInitials(name) : null);
}
AvatarName.displayName = "AvatarName";

// src/generic-avatar-icon.tsx

var GenericAvatarIcon = (props) => /* @__PURE__ */ react.createElement(index_esm/* chakra.svg */.m$.svg, {
  viewBox: "0 0 128 128",
  color: "#fff",
  width: "100%",
  height: "100%",
  className: "chakra-avatar__svg",
  ...props
}, /* @__PURE__ */ react.createElement("path", {
  fill: "currentColor",
  d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
}), /* @__PURE__ */ react.createElement("path", {
  fill: "currentColor",
  d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
}));

// src/avatar-image.tsx
function AvatarImage(props) {
  const {
    src,
    srcSet,
    onError,
    onLoad,
    getInitials,
    name,
    borderRadius,
    loading,
    iconLabel,
    icon = /* @__PURE__ */ react.createElement(GenericAvatarIcon, null),
    ignoreFallback,
    referrerPolicy
  } = props;
  const status = useImage({ src, onError, ignoreFallback });
  const hasLoaded = status === "loaded";
  const showFallback = !src || !hasLoaded;
  if (showFallback) {
    return name ? /* @__PURE__ */ react.createElement(AvatarName, {
      className: "chakra-avatar__initials",
      getInitials,
      name
    }) : (0,react_production_min.cloneElement)(icon, {
      role: "img",
      "aria-label": iconLabel
    });
  }
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.img */.m$.img, {
    src,
    srcSet,
    alt: name,
    onLoad,
    referrerPolicy,
    className: "chakra-avatar__img",
    loading,
    __css: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius
    }
  });
}
AvatarImage.displayName = "AvatarImage";

// src/avatar.tsx

var baseStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  textTransform: "uppercase",
  fontWeight: "medium",
  position: "relative",
  flexShrink: 0
};
var Avatar = (0,index_esm/* forwardRef */.Gp)((props, ref) => {
  const styles = (0,index_esm/* useMultiStyleConfig */.jC)("Avatar", props);
  const [isLoaded, setIsLoaded] = (0,react_production_min.useState)(false);
  const {
    src,
    srcSet,
    name,
    showBorder,
    borderRadius = "full",
    onError,
    onLoad: onLoadProp,
    getInitials = initials,
    icon = /* @__PURE__ */ react.createElement(GenericAvatarIcon, null),
    iconLabel = " avatar",
    loading,
    children,
    borderColor,
    ignoreFallback,
    ...rest
  } = (0,dist_index_esm/* omitThemingProps */.Lr)(props);
  const avatarStyles = {
    borderRadius,
    borderWidth: showBorder ? "2px" : void 0,
    ...baseStyle,
    ...styles.container
  };
  if (borderColor) {
    avatarStyles.borderColor = borderColor;
  }
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.span */.m$.span, {
    ref,
    ...rest,
    className: cx("chakra-avatar", props.className),
    "data-loaded": dataAttr(isLoaded),
    __css: avatarStyles
  }, /* @__PURE__ */ react.createElement(AvatarStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react.createElement(AvatarImage, {
    src,
    srcSet,
    loading,
    onLoad: callAllHandlers(onLoadProp, () => {
      setIsLoaded(true);
    }),
    onError,
    getInitials,
    name,
    borderRadius,
    icon,
    iconLabel,
    ignoreFallback
  }), children));
});
Avatar.displayName = "Avatar";

// src/avatar-group.tsx



// ../../utilities/object-utils/src/index.ts
function compact(object) {
  const clone = Object.assign({}, object);
  for (let key in clone) {
    if (clone[key] === void 0)
      delete clone[key];
  }
  return clone;
}

// src/avatar-group.tsx

var AvatarGroup = (0,index_esm/* forwardRef */.Gp)(function AvatarGroup2(props, ref) {
  const styles = (0,index_esm/* useMultiStyleConfig */.jC)("Avatar", props);
  const {
    children,
    borderColor,
    max,
    spacing = "-0.75rem",
    borderRadius = "full",
    ...rest
  } = (0,dist_index_esm/* omitThemingProps */.Lr)(props);
  const validChildren = (0,react_children_utils_dist_index_esm/* getValidChildren */.W)(children);
  const childrenWithinMax = max ? validChildren.slice(0, max) : validChildren;
  const excess = max != null && validChildren.length - max;
  const reversedChildren = childrenWithinMax.reverse();
  const clones = reversedChildren.map((child, index) => {
    const isFirstAvatar = index === 0;
    const childProps = {
      marginEnd: isFirstAvatar ? 0 : spacing,
      size: props.size,
      borderColor: child.props.borderColor ?? borderColor,
      showBorder: true
    };
    return (0,react_production_min.cloneElement)(child, compact(childProps));
  });
  const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexDirection: "row-reverse",
    ...styles.group
  };
  const excessStyles = {
    borderRadius,
    marginStart: spacing,
    ...baseStyle,
    ...styles.excessLabel
  };
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    ref,
    role: "group",
    __css: groupStyles,
    ...rest,
    className: cx("chakra-avatar__group", props.className)
  }, excess > 0 && /* @__PURE__ */ react.createElement(index_esm/* chakra.span */.m$.span, {
    className: "chakra-avatar__excess",
    __css: excessStyles
  }, `+${excess}`), clones);
});
AvatarGroup.displayName = "AvatarGroup";

// src/avatar-badge.tsx

var placementMap = {
  "top-start": {
    top: "0",
    insetStart: "0",
    transform: "translate(-25%, -25%)"
  },
  "top-end": {
    top: "0",
    insetEnd: "0",
    transform: "translate(25%, -25%)"
  },
  "bottom-start": {
    bottom: "0",
    insetStart: "0",
    transform: "translate(-25%, 25%)"
  },
  "bottom-end": {
    bottom: "0",
    insetEnd: "0",
    transform: "translate(25%, 25%)"
  }
};
var AvatarBadge = (0,index_esm/* forwardRef */.Gp)(function AvatarBadge2(props, ref) {
  const { placement = "bottom-end", className, ...rest } = props;
  const styles = useAvatarStyles();
  const placementStyles = placementMap[placement];
  const badgeStyles = {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...placementStyles,
    ...styles.badge
  };
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    ref,
    ...rest,
    className: cx("chakra-avatar__badge", className),
    __css: badgeStyles
  });
});
AvatarBadge.displayName = "AvatarBadge";



/***/ }),

/***/ 38030:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[category]/overview",
      function () {
        return __webpack_require__(84818);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ DocsTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react/cjs/react.production.min.js
var react_production_min = __webpack_require__(72408);
// EXTERNAL MODULE: ./utils/normalize-string.ts
var normalize_string = __webpack_require__(35182);
;// CONCATENATED MODULE: ./components/docs/page/template/table-of-contents.tsx
// TODO: remove ts-nocheck and fix warnings and errors on this file
// @ts-nocheck




function TableOfContents(param) {
    let { content  } = param;
    const [activeId, setActiveId] = (0,react_production_min.useState)("");
    const { toKebabCase  } = normalize_string/* normalizeString */.U;
    const callback = (entries)=>{
        const intersections = entries.reduce((acc, entry)=>{
            // Add intersecting entries to array
            return entry.isIntersecting ? acc.concat(entry) : acc;
        }, []);
        if (intersections[0]) {
            var ref, ref1;
            // Get ID from first intersection entry
            setActiveId((ref = intersections[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.target) === null || ref1 === void 0 ? void 0 : ref1.id);
        }
    };
    const headingsData = content === null || content === void 0 ? void 0 : content.reduce((acc, cur)=>{
        if (cur._type === "block" && [
            "h2",
            "h3"
        ].includes(cur.style)) {
            var ref;
            const text = (ref = cur.children[0]) === null || ref === void 0 ? void 0 : ref.text;
            if (text) {
                acc.push({
                    id: toKebabCase(text),
                    element: cur.style,
                    text
                });
            }
        }
        return acc;
    }, []);
    (0,react_production_min.useEffect)(()=>{
        let observer;
        if ("IntersectionObserver" in window) {
            observer = new IntersectionObserver(callback);
            headingsData.forEach((item)=>{
                const heading = document.getElementById(item.id);
                observer.observe(heading);
            });
        }
        return ()=>{
            observer.disconnect();
        };
    }, [
        headingsData
    ]);
    if (!headingsData.length) {
        // No headings for ToC
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        as: "nav",
        "aria-label": "Table of Contents",
        bg: "var(--bodyBg)",
        pos: "sticky",
        top: "105px",
        display: {
            base: "none",
            xl: "block"
        },
        w: "280px",
        h: "calc(100vh - 120px)",
        pb: 12,
        pl: 8,
        overflow: "auto",
        flexShrink: 0,
        sx: {
            msOverflowStyle: "none" /* IE and Edge */ ,
            scrollbarWidth: "none" /* Firefox */ ,
            "&::-webkit-scrollbar": {
                display: "none" /* Chrome, Safari and Opera */ 
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* UnorderedList */.QI, {
            children: headingsData.map((param, index)=>{
                let { id , element , text  } = param;
                const isActive = id === activeId;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                    listStyleType: "none",
                    borderLeft: "1px solid",
                    borderColor: isActive ? "var(--primaryBlue)" : "var(--borderColor)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        as: "a",
                        href: "#".concat(id),
                        textStyle: "xs-medium",
                        color: isActive ? "var(--primaryTextColor)" : "var(--secondaryTextColor)",
                        display: "block",
                        px: 4,
                        py: 1.5,
                        ml: element !== "h2" ? 4 : 0,
                        transition: "color 0.2s",
                        _hover: {
                            color: "var(--primaryTextColor)"
                        },
                        onClick: (event)=>{
                            event.preventDefault();
                            if (true) {
                                window.history.pushState(null, "", "#".concat(id));
                                window.scroll({
                                    top: document.getElementById(id).offsetTop - 80,
                                    behavior: "smooth"
                                });
                            }
                        },
                        children: text
                    })
                }, "".concat(id, "-").concat(index));
            })
        })
    });
}

// EXTERNAL MODULE: ./components/sanity/sane-block.tsx + 14 modules
var sane_block = __webpack_require__(51061);
// EXTERNAL MODULE: ./components/docs/page/page-container.tsx
var page_container = __webpack_require__(29856);
// EXTERNAL MODULE: ./pages/index.tsx + 31 modules
var pages = __webpack_require__(16263);
;// CONCATENATED MODULE: ./components/docs/page/template/template.tsx







function DocsTemplate(param) {
    let { content  } = param;
    (0,react_production_min.useEffect)(()=>{
        pages.analytics.track("Docs_Page_".concat(content.title, " Viewed"), {
            surface: "Docs",
            location: "Page"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(page_container/* PageContainer */._, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
            py: 12,
            mx: "auto",
            justify: "center",
            color: "var(--primaryTextColor)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    px: {
                        base: 6,
                        lg: 10
                    },
                    sx: {
                        maxW: "full",
                        // Chakra's `xl` breakpoint; table of contents appears here
                        "@media screen and (min-width: 1280px)": {
                            maxW: "container.sm"
                        },
                        "@media screen and (min-width: 1400px)": {
                            maxW: "container.md"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            as: "h1",
                            size: "h4",
                            mb: 3,
                            color: "var(--primaryTextColor)",
                            children: content.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            as: "h3",
                            textStyle: "md-normal",
                            color: "var(--secondaryTextColor)",
                            mb: 6,
                            children: content.subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sane_block/* SaneBlockChakra */.C, {
                            blocks: content.body
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOfContents, {
                    content: content.body
                })
            ]
        })
    });
}


/***/ }),

/***/ 87585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pk": function() { return /* binding */ tutorialQuery; },
/* harmony export */   "Tc": function() { return /* binding */ docBySlugQuery; },
/* harmony export */   "Zk": function() { return /* binding */ blogQuery; }
/* harmony export */ });
/* unused harmony exports blogIndexQueryProduction, blogIndexQueryPreview, guidesIndexQueryProduction, guidesIndexQueryPreview, authorQuery, investorQuery, docQuery, pageQuery, siteSettingsQuery, blogSlugsQueryProduction, blogSlugsQueryPreview, blogBySlugQuery, tutorialSlugsQueryProduction, tutorialSlugsQueryPreview, tutorialBySlugQuery, marketingLPSlugsQuery, marketingLPBySlugQuery, docSlugsQuery, navigationQuery */
const blogFields = '\n  _id,\n  name,\n  title,\n  date,\n  excerpt,\n  coverImage,\n  category,\n  mdx,\n  live,\n  "slug": slug.current,\n  "author": author->{name, picture},\n  seo,\n  featured\n';
const tutorialFields = '\n_id,\nname,\ntitle,\nexcerpt,\ncoverImage,\ncategory,\nlive,\n"slug": slug.current,\n"author": author->{name, picture},\ntime,\nmarkdown,\nbody[] {\n  ...,\n  markDefs[]{\n    ...,\n    _type == "internalLink" => {\n      "slug": @.reference->slug\n    }\n  },\n  body[] {\n    ...,\n    markDefs[]{\n      ...,\n      _type == "internalLink" => {\n        "slug": @.reference->slug\n      }\n    }\n  },\n},\nseo\n';
const docFields = '\n  _id,\n  seo,\n  title,\n  subtitle,\n  body[] {\n    ...,\n    markDefs[]{\n      ...,\n      _type == "internalLink" => {\n        "slug": @.reference->slug\n      }\n    },\n    body[] {\n      ...,\n      markDefs[]{\n        ...,\n        _type == "internalLink" => {\n          "slug": @.reference->slug\n        }\n      }\n    },\n  },\n  "slug": slug.current\n';
const authorFields = "\n  _id,\n  name,\n  picture,\n  role,\n  socials,\n  teammate\n";
const investorFields = "\n  _id,\n  name,\n  picture,\n  role,\n  url\n";
const pageFields = '\n  _id,\n  seo,\n  pageText,\n  pageCode,\n  pageImage,\n  pageJSON,\n  body[]{\n    ...,\n    richText[]{\n      ...,\n      markDefs[]{\n        ...,\n        _type == "internalLink" => {\n          "slug": @.reference->slug\n        }\n      }\n    }\n  },\n  "slug": slug.current,\n';
const blogIndexQueryProduction = "\n*[_type == \"blog\" && live == true && !(_id in path('drafts.**'))] | order(date desc, _updatedAt desc) {\n  ".concat(blogFields, "\n}");
const blogIndexQueryPreview = "\n*[_type == \"blog\" && !(_id in path('drafts.**'))]  | order(date desc, _updatedAt desc) {\n  ".concat(blogFields, "\n}");
const guidesIndexQueryProduction = '\n*[(_type == \'tutorial\' || _type == "blog") && live == true && (category == "Guide" || category == "Tutorial") && !(_id in path(\'drafts.**\'))] | order(date desc, _updatedAt desc) {\n  '.concat(blogFields, "\n}");
const guidesIndexQueryPreview = '\n*[(_type == \'tutorial\' || _type == "blog") && (category == "Guide" || category == "Tutorial") && !(_id in path(\'drafts.**\'))] | order(date desc, _updatedAt desc) {\n  '.concat(blogFields, "\n}");
const authorQuery = '\n*[_type == "author"] | order(order asc) {\n  '.concat(authorFields, "\n}");
const investorQuery = '\n*[_type == "investor"] | order(order asc) {\n  '.concat(investorFields, "\n}");
const docQuery = '\n*[_type == "doc"] {\n    _id,\n  title,\n  "slug": slug.current\n}';
const blogQuery = '\n{\n  "blog": *[_type == "blog" && slug.current == $slug] | order(_updatedAt desc)[0]{\n    "body": body[]{\n      ...,\n      authors[]->,\n      markDefs[]{\n        ...,\n        _type == "internalLink" => {\n          "slug": @.reference->slug\n        }\n      },\n      body[] {\n        ...,\n        markDefs[]{\n          ...,\n          _type == "internalLink" => {\n            "slug": @.reference->slug\n          }\n        }\n      }\n},\n    '.concat(blogFields, '\n  },\n  "moreBlogs": *[_type == "blog" && slug.current != $slug] | order(date desc, _updatedAt desc)[0...2] {\n    "body": body[]{\n      ...,\n      authors[]->,\n},\n    ').concat(blogFields, "\n  }\n}");
const tutorialQuery = '\n{\n  "tutorial": *[_type == "tutorial" && slug.current == $slug] | order(_updatedAt desc)[0]{\n    "body": body[]{\n      ...,\n      authors[]->,\n},\n    '.concat(tutorialFields, '\n  },\n  "moreTutorials": *[_type == "tutorial" && slug.current != $slug] | order(date desc, _updatedAt desc)[0...2] {\n    "body": body[]{\n      ...,\n      authors[]->,\n},\n    ').concat(tutorialFields, "\n  }\n}");
const pageQuery = '\n{\n  "page": *[_type == "page" && slug.current == $slug] | order(_updatedAt desc)[0] {\n    content,\n    '.concat(pageFields, "\n  },\n}");
const siteSettingsQuery = '\n*[_type == "siteSettings"] | order(order asc)';
const blogSlugsQueryProduction = '\n*[_type == "blog" && live == true && defined(slug.current)][].slug.current\n';
const blogSlugsQueryPreview = '\n*[_type == "blog" && defined(slug.current)][].slug.current\n';
const blogBySlugQuery = '\n*[_type == "blog" && slug.current == $slug][0] {\n  '.concat(blogFields, "\n}\n");
const tutorialSlugsQueryProduction = '\n*[_type == "tutorial" && live == true && defined(slug.current)][].slug.current\n';
const tutorialSlugsQueryPreview = '\n*[_type == "tutorial" && defined(slug.current)][].slug.current\n';
const tutorialBySlugQuery = '\n*[_type == "tutorial" && slug.current == $slug][0] {\n  '.concat(tutorialFields, "\n}\n");
const marketingLPSlugsQuery = '\n*[_type == "marketing-lp" && defined(slug.current)][].slug.current\n';
const marketingLPBySlugQuery = '\n{\n  "page": *[_type == "marketing-lp" && slug.current == $slug][0] {\n    '.concat(pageFields, "\n  }\n}\n");
const docSlugsQuery = '\n*[_type == "doc" && defined(slug.current)][].slug.current\n';
const docBySlugQuery = '\n*[_type == "doc" && slug.current == $slug] | order(_updatedAt desc)[0] {\n  '.concat(docFields, "\n}\n");
const navigationQuery = '\n*[navId.current match "docs-*"] | order(order asc) {\n  name,\n "navId": navId.current,\n "categories": linkCategories[]{\n   "categoryId": categoryId.current,\n   categoryName,\n   links[] {\n     _key,\n     title,\n     "slug": internalLink->slug.current,\n     "url": externalLink.href,\n     "childLinks": links[]{\n       _key, \n       title, \n       "slug": internalLink->slug.current, \n       "url": externalLink.href\n     }\n   }\n }\n}\n';


/***/ }),

/***/ 84818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ DocsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(12918);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lib/queries.js
var queries = __webpack_require__(87585);
// EXTERNAL MODULE: ./lib/sanity.js + 3 modules
var sanity = __webpack_require__(53822);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/index.esm.js
var dist_index_esm = __webpack_require__(8395);
// EXTERNAL MODULE: ./components/docs/page/page-container.tsx
var page_container = __webpack_require__(29856);
// EXTERNAL MODULE: ./components/docs/page/home/cta-card.tsx
var cta_card = __webpack_require__(23649);
// EXTERNAL MODULE: ./components/docs/page/home/content.ts
var home_content = __webpack_require__(51297);
// EXTERNAL MODULE: ./components/sanity/sane-block.tsx + 14 modules
var sane_block = __webpack_require__(51061);
// EXTERNAL MODULE: ./components/docs/page/home/support.tsx
var support = __webpack_require__(19630);
;// CONCATENATED MODULE: ./components/docs/page/nextjs/overview.tsx







function NextjsOverview(param) {
    let { content , guides  } = param;
    const { colorMode  } = (0,dist_index_esm/* useColorMode */.If)();
    const isLightMode = colorMode === "light";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(page_container/* PageContainer */._, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                pt: {
                    base: 6,
                    lg: 8,
                    xl: 12
                },
                borderBottom: "1px solid",
                borderColor: "var(--borderColor)",
                bg: "var(--bodyBg)",
                color: "var(--primaryTextColor)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    maxW: "container.lg",
                    mx: "auto",
                    px: {
                        base: 6,
                        lg: 10
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            as: "h1",
                            color: "var(--primaryTextColor)",
                            size: "h4",
                            fontWeight: "medium",
                            mb: 2,
                            children: content.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sane_block/* SaneBlockChakra */.C, {
                            blocks: content.body
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                spacing: 12,
                py: 12,
                px: {
                    base: 6,
                    lg: 10
                },
                maxW: "container.lg",
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
                        pb: 6,
                        spacing: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                            columns: {
                                base: 1,
                                md: 2,
                                xl: 3
                            },
                            gap: 6,
                            w: "full",
                            children: (0,home_content/* nextjsOverview */.AU)(isLightMode).map((param)=>/*#__PURE__*/ {
                                let { title , description , url , logo , logoHeight , logoWidth  } = param;
                                return (0,jsx_runtime.jsx)(cta_card/* CtaCard */.K, {
                                    title: title,
                                    description: description,
                                    url: url,
                                    logo: logo,
                                    logoHeight: logoHeight,
                                    logoWidth: logoWidth,
                                    ctaText: "Learn more"
                                }, title);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(support/* Support */.B, {})
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/docs/page/home/section-heading.tsx
var section_heading = __webpack_require__(66275);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/avatar/dist/index.esm.js + 1 modules
var avatar_dist_index_esm = __webpack_require__(93345);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/sanity/sane-image.tsx
var sane_image = __webpack_require__(27013);
;// CONCATENATED MODULE: ./components/docs/page/template/post-card.tsx





function PostCard(props) {
    const { post  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
        py: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: post.slug,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                as: "a",
                layerStyle: "linkCard",
                direction: "column",
                w: "full",
                h: "full",
                bg: "var(--cardBg)",
                p: 0,
                overflow: "hidden",
                _hover: {
                    boxShadow: (0,dist_index_esm/* useColorModeValue */.ff)("dropShadow2", "dropShadow1")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        h: "157px",
                        bg: "var(--bodyBg)",
                        pos: "relative",
                        display: {
                            base: "none",
                            xl: "block"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sane_image/* SaneImage */.Q, {
                            layout: "fill",
                            alt: post.title,
                            src: post.coverImage,
                            height: undefined,
                            width: undefined,
                            wrapClassName: undefined
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                        justify: "space-between",
                        flex: 1,
                        p: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        color: "var(--secondaryTextColor)",
                                        textTransform: "uppercase",
                                        fontWeight: 700,
                                        textStyle: "xs-semibold",
                                        letterSpacing: 1.1,
                                        children: post.category
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                        size: "2xs",
                                        color: "var(--primaryTextColor)",
                                        children: post.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        color: "var(--secondaryTextColor)",
                                        textStyle: "xs-normal",
                                        children: post.excerpt
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                                mt: "auto",
                                pt: 4,
                                direction: "row",
                                spacing: 4,
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                        src: (0,sanity/* urlForImage */.iQ)(post.author.picture.asset).url(),
                                        name: post.author.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        color: "var(--primaryTextColor)",
                                        fontSize: "sm",
                                        fontWeight: 600,
                                        children: post.author.name
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/docs/page/template/quickstarts.tsx








function DocsQuickstarts(param) {
    let { content , guides  } = param;
    const { colorMode  } = (0,dist_index_esm/* useColorMode */.If)();
    const isLightMode = colorMode === "light";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(page_container/* PageContainer */._, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                py: {
                    base: 12,
                    lg: 16,
                    xl: 24
                },
                borderBottom: "1px solid",
                borderColor: "var(--borderColor)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    maxW: "container.lg",
                    mx: "auto",
                    px: {
                        base: 6,
                        lg: 10
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        as: "h1",
                        color: "var(--primaryTextColor)",
                        size: "h4",
                        fontWeight: "medium",
                        mb: 2,
                        children: content.title
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                spacing: 12,
                py: 12,
                px: {
                    base: 6,
                    lg: 10
                },
                maxW: "container.lg",
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(section_heading/* SectionHeading */.O, {
                                thinText: "Get started",
                                boldText: "quickly"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                columns: {
                                    base: 1,
                                    md: 2,
                                    xl: 3
                                },
                                gap: 6,
                                w: "full",
                                children: (0,home_content/* frontendSuggestions */.jz)(isLightMode).map((param)=>/*#__PURE__*/ {
                                    let { title , description , url , logo , logoHeight , logoWidth  } = param;
                                    return (0,jsx_runtime.jsx)(cta_card/* CtaCard */.K, {
                                        title: title,
                                        description: description,
                                        url: url,
                                        logo: logo,
                                        logoHeight: logoHeight,
                                        logoWidth: logoWidth,
                                        ctaText: "Learn more"
                                    }, title);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(section_heading/* SectionHeading */.O, {
                                thinText: "Learn",
                                boldText: "by example"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                columns: {
                                    base: 1,
                                    md: 2,
                                    xl: 3
                                },
                                gap: 6,
                                w: "full",
                                children: guides.slice(0, 9).map((guide)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostCard, {
                                        post: guide
                                    }, guide._id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        pt: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(support/* Support */.B, {})
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/docs/page/template/component-reference.tsx






function DocsComponentReference(param) {
    let { content  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(page_container/* PageContainer */._, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                py: {
                    base: 12,
                    lg: 16,
                    xl: 24
                },
                borderBottom: "1px solid",
                borderColor: "var(--borderColor)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    maxW: "container.lg",
                    mx: "auto",
                    px: {
                        base: 6,
                        lg: 10
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        as: "h1",
                        color: "var(--primaryTextColor)",
                        size: "h4",
                        fontWeight: "medium",
                        mb: 2,
                        children: content.title
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                spacing: 12,
                py: 12,
                px: {
                    base: 6,
                    lg: 10
                },
                maxW: "container.lg",
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                        columns: {
                            base: 1,
                            md: 2
                        },
                        gap: 6,
                        w: "full",
                        children: home_content/* componentReference.map */.Dk.map((param)=>/*#__PURE__*/ {
                            let { title , description , url , icon  } = param;
                            return (0,jsx_runtime.jsx)(cta_card/* CtaCard */.K, {
                                title: title,
                                description: description,
                                url: url,
                                icon: icon,
                                ctaText: "Get started",
                                size: "lg"
                            }, title);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        pt: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(support/* Support */.B, {})
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/docs/page/template/api-reference.tsx






const SDKs = (isLightMode)=>[
        {
            title: "React",
            description: "Clerk React is the recommended way to integrate Clerk into your React application.",
            url: "/docs/reference/clerk-react/installation",
            logo: "/images/logos/react.svg"
        },
        {
            title: "JavaScript",
            description: "ClerkJS is our foundational JavaScript library for building user management and authentication.",
            url: "/docs/reference/clerkjs/installation",
            logo: "/images/logos/javascript.svg"
        },
        {
            title: "Node.js",
            description: "Clerk Node SDK is the recommend way to integrate Clerk into your Node / Express application.",
            url: "/docs/reference/node/getting-started",
            logo: isLightMode ? "/images/logos/node.svg" : "/images/logos/node-white.svg",
            logoWidth: 40
        },
        {
            title: "React Native / Expo",
            description: "Clerk Expo is the recommended way to integrate Clerk into your React Native application.",
            url: "/docs/quickstarts/get-started-with-expo",
            logo: isLightMode ? "/images/logos/expo.svg" : "/images/logos/expo-white.svg"
        },
        {
            title: "Go",
            description: "Clerk Go SDK is a wrapper around our Backend API written in Golang.",
            url: "/docs/reference/golang/getting-started",
            logo: "/images/logos/go.svg",
            logoWidth: 40
        },
        {
            title: "Ruby",
            description: "Clerk Ruby is the recommended way to integrate Clerk into your Ruby application.",
            url: "/docs/reference/ruby/getting-started",
            logo: "/images/logos/ruby.svg"
        }
    ];
function DocsAPIReference(param) {
    let { content  } = param;
    const { colorMode  } = (0,dist_index_esm/* useColorMode */.If)();
    const isLightMode = colorMode === "light";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(page_container/* PageContainer */._, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                py: {
                    base: 12,
                    lg: 16,
                    xl: 24
                },
                borderBottom: "1px solid",
                borderColor: "var(--borderColor)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    maxW: "container.lg",
                    mx: "auto",
                    px: {
                        base: 6,
                        lg: 10
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        as: "h1",
                        color: "var(--primaryTextColor)",
                        size: "h4",
                        fontWeight: "medium",
                        mb: 2,
                        children: content.title
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                spacing: 12,
                py: 12,
                px: {
                    base: 6,
                    lg: 10
                },
                maxW: "container.lg",
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section_heading/* SectionHeading */.O, {
                        thinText: "Build with",
                        boldText: "Clerk SDKs"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                        columns: {
                            base: 1,
                            md: 2,
                            xl: 3
                        },
                        gap: 6,
                        w: "full",
                        children: SDKs(isLightMode).map((param)=>/*#__PURE__*/ {
                            let { title , description , url , logo , logoWidth  } = param;
                            return (0,jsx_runtime.jsx)(cta_card/* CtaCard */.K, {
                                title: title,
                                description: description,
                                url: url,
                                logo: logo,
                                logoWidth: logoWidth,
                                ctaText: "Start building"
                            }, title);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        pt: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(support/* Support */.B, {})
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/docs/page/template/integrations.tsx







function DocsIntegrations(param) {
    let { content  } = param;
    const { colorMode  } = (0,dist_index_esm/* useColorMode */.If)();
    const isLightMode = colorMode === "light";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(page_container/* PageContainer */._, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                py: {
                    base: 12,
                    lg: 16,
                    xl: 24
                },
                borderBottom: "1px solid",
                borderColor: "var(--borderColor)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    maxW: "container.lg",
                    mx: "auto",
                    px: {
                        base: 6,
                        lg: 10
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        as: "h1",
                        color: "var(--primaryTextColor)",
                        size: "h4",
                        fontWeight: "medium",
                        mb: 2,
                        children: content.title
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                spacing: 12,
                py: 12,
                px: {
                    base: 6,
                    lg: 10
                },
                maxW: "container.lg",
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(section_heading/* SectionHeading */.O, {
                                thinText: "Connect with",
                                boldText: "databases and more"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                columns: {
                                    base: 1,
                                    md: 2,
                                    xl: 3
                                },
                                gap: 6,
                                w: "full",
                                children: (0,home_content/* integrationSuggestions */.DV)(isLightMode).map((param)=>/*#__PURE__*/ {
                                    let { title , description , url , logo , logoWidth  } = param;
                                    return (0,jsx_runtime.jsx)(cta_card/* CtaCard */.K, {
                                        title: title,
                                        description: description,
                                        url: url,
                                        logo: logo,
                                        logoWidth: logoWidth,
                                        ctaText: "Connect now"
                                    }, title);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        pt: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(support/* Support */.B, {})
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/docs/page/template/template.tsx + 1 modules
var template = __webpack_require__(62281);
// EXTERNAL MODULE: ./components/docs/layout/sidenav.tsx
var sidenav = __webpack_require__(32596);
// EXTERNAL MODULE: ./components/docs/layout/header.tsx + 6 modules
var header = __webpack_require__(6903);
// EXTERNAL MODULE: ./components/docs/layout/footer.tsx + 1 modules
var footer = __webpack_require__(36651);
// EXTERNAL MODULE: ./lib/constants.ts
var constants = __webpack_require__(58038);
// EXTERNAL MODULE: ./hooks/use-route-scroll.ts
var use_route_scroll = __webpack_require__(8253);
// EXTERNAL MODULE: ./node_modules/react/cjs/react.production.min.js
var react_production_min = __webpack_require__(72408);
// EXTERNAL MODULE: ./pages/index.tsx + 31 modules
var pages = __webpack_require__(16263);
;// CONCATENATED MODULE: ./components/docs/page/overview/overview.tsx







function renderTemplate(props) {
    const { data , guides , query  } = props;
    if (data.slug === "/docs/nextjs/overview") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextjsOverview, {
            content: data,
            guides: []
        });
    }
    switch(query.category){
        case constants/* DOCS_CATEGORIES.quickstarts */.vR.quickstarts:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DocsQuickstarts, {
                content: data,
                guides: guides
            });
        case constants/* DOCS_CATEGORIES.componentReference */.vR.componentReference:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DocsComponentReference, {
                content: data
            });
        case constants/* DOCS_CATEGORIES.apiReference */.vR.apiReference:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DocsAPIReference, {
                content: data
            });
        case constants/* DOCS_CATEGORIES.integrations */.vR.integrations:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DocsIntegrations, {
                content: data
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(template/* DocsTemplate */.g, {
                content: props.data
            });
    }
}
function DocsOverview(props) {
    const { navigation  } = props;
    const capitalize = (s)=>s && s[0].toUpperCase() + s.slice(1) || "";
    (0,react_production_min.useEffect)(()=>{
        const mySubString = props.data.slug.substring(props.data.slug.indexOf("docs/") + 5, props.data.slug.lastIndexOf("/overview"));
        pages.analytics.track("Docs_".concat(capitalize(mySubString), "_Overview Viewed"), {
            surface: "Docs",
            location: "Page"
        });
    }, []);
    (0,use_route_scroll/* useRouteScroll */.t)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        minH: "100vh",
        bg: "white",
        color: "black",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sidenav/* DocsSidenav */.x, {
                navigation: navigation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* DocsHeader */.U, {
                navigation: navigation
            }),
            renderTemplate(props),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* DocsFooter */.E, {})
        ]
    });
}

;// CONCATENATED MODULE: ./pages/docs/[category]/overview.tsx






var __N_SSG = true;
function DocsPage(param) {
    let { data , preview , guides , navigation  } = param;
    const router = (0,next_router.useRouter)();
    const { slug  } = data;
    const { data: docData  } = (0,sanity/* usePreviewSubscription */.$r)(queries/* docBySlugQuery */.Tc, {
        params: {
            slug
        },
        initialData: data,
        enabled: preview && slug
    });
    if (!data || !router.isFallback && !data.slug) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(error["default"], {
            statusCode: 404
        });
    }
    return router.isFallback ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "Loading..."
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DocsOverview, {
        data: docData,
        guides: guides,
        query: router.query,
        navigation: navigation
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6241,9385,2868,659,1061,617,174,9774,2888,179], function() { return __webpack_exec__(38030); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);